<template>
  <div class="product">
    <div class="banner">
      <img src="../assets/img/4_1.jpg" alt="banner">
    </div>
    <div class="content">
      <div class="header">
        <div class="left">PRODUCT</div>
        <div class="right">速绿全线产品</div>
      </div>
      <p class="desc">产品自主研发生产，完善的技术管理体系</p>
      <ul class="pro-tabs">
        <li :class="{'current': type=='all'}" data-pindex="0" data-type="all" @click="changeType">速绿全线产品</li>
        <li :class="{'current': type=='battery'}" data-pindex="1" data-type="battery" @click="changeType">便携充电宝</li>
        <li :class="{'current': type=='desk5'}" data-pindex="2" data-type="desk5" @click="changeType">桌面式5槽</li>
        <li :class="{'current': type=='desk10'}" data-pindex="3" data-type="desk10" @click="changeType">桌面式10槽</li>
        <li :class="{'current': type=='desk15'}" data-pindex="4" data-type="desk15" @click="changeType">桌面式15槽</li>
        <li :class="{'current': type=='outdoor'}" data-pindex="5" data-type="outdoor" @click="changeType">室外机20槽</li>
        <li :class="{'current': type=='adv'}" data-pindex="6" data-type="adv" @click="changeType">广告机40槽</li>
        <li :class="{'current': type=='blue'}" data-pindex="7" data-type="blue" @click="changeType">蓝 牙 线 充</li>
      </ul>
      <div class="imgBox">
        <img src="../assets/img/product_all.jpg" alt="全线产品图" v-if="type=='all'" style="width: 100%; margin: .8rem 0;">
        <img src="../assets/img/product_battery.jpg" alt="便携充电宝" v-if="type=='battery'" style="width: 5.8rem;">
        <img src="../assets/img/product_desk_5.jpg" alt="桌面式5槽" v-if="type=='desk5'" style="width: 5.7rem; margin-bottom: -.3rem;">
        <img src="../assets/img/product_desk_10.jpg" alt="桌面式10槽" v-if="type=='desk10'" style="width: 5.8rem;">
        <img src="../assets/img/product_desk_15.jpg" alt="桌面式15槽" v-if="type=='desk15'" style="width: 6.34rem;">
        <img src="../assets/img/product_outdoor.jpg" alt="室外机20槽" v-if="type=='outdoor'" style="width: 6.3rem;">
        <img src="../assets/img/product_adv.jpg" alt="广告机40槽" v-if="type=='adv'" style="width: 6.1rem; margin-bottom: -.32rem;">
        <img src="../assets/img/product_blue.jpg" alt="蓝牙线充" v-if="type=='blue'" style="width: 6.1rem; margin-bottom: .6rem;">
        <div class="arrow-left" @click="changeLeft"></div>
        <div class="arrow-right" @click="changeRight"></div>
      </div>
      <div class="alt-img-box">
        <img src="../assets/img/advantageIcons.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      proList: ["all", "battery", "desk5", "desk10", "desk15", "outdoor", "adv", "blue"],
      type: "all",
      proIndex: 0
    };
  },
  components: {},
  mounted () {},
  methods: {
      // 切换标签
      changeType: function (event) {
          this.type = event.target.dataset.type;
          this.proIndex = event.target.dataset.pindex - 0;
      },
      // 点击左箭头
      changeLeft: function () {
          var proIndex = this.proIndex;
          if(proIndex > 0) {
              proIndex -= 1;
              this.proIndex = proIndex;
              this.type = this.proList[proIndex];
          }
      },
      // 点击右箭头
      changeRight: function () {
          var proIndex = this.proIndex;
          if(proIndex < this.proList.length - 1) {
              proIndex += 1;
              this.proIndex = proIndex;
              this.type = this.proList[proIndex];
          }
      }
  }
}
</script>

<style lang='scss' scoped>
  h1, h2, h3, h4, h5, p, ul, li {
    margin: 0;
    padding: 0;
    font-weight: normal;
  }
  ul {
    list-style: none;
  }
  .product {
    width: 100%;
    overflow-x: hidden;
  }
  .banner {
    width: 100%;
  }
  .banner img {
    width: 100%;
    vertical-align: top;
  }
  .content {
    padding: .3rem .26rem 0;
  }
  .header {
    height: 0.44rem;
    font-size: 0.36rem;
    text-align: left;
  }
  .header div {
    display: inline-block;
    vertical-align: middle;
  }
  .header .left {
    font-size: 0.24rem;
    color: #e8e8e8;
    font-weight: 700;
  }
  .header .left::after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: .16rem;
    margin: -.04rem 0.12rem 0 0.12rem;
    border-right: 1px solid #2fb15a;
  }
  .header .right {
    font-size: .25rem;
    color: #000000;
  }
  .desc {
    margin-top: .16rem;
    font-size: .18rem;
    color: #000000;
    text-align: left;
  }
  .pro-tabs {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: 1.8rem;
    margin-top: .3rem;
    text-align: center;
  }
  .pro-tabs li {
    flex: 25%;
    box-sizing: border-box;
    height: .68rem;
    border: 1px solid #2fb15a;
    margin-bottom: .38rem;
    line-height: .68rem;
    font-size: .24rem;
    color: #2fb15a;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }
  .pro-tabs li.current {
    background-color: #2fb15a;
    color: #ffffff;
  }
  .imgBox {
    position: relative;
    padding-top: .35rem;
    padding-bottom: .2rem;
    text-align: left;
  }
  .imgBox img {
    vertical-align: top;
  }
  .imgBox .arrow-left {
    position: absolute;
    left: 0;
    top: 3.7rem;
    width: .4rem;
    height: .4rem;
    -webkit-border-radius: .2rem;
    border-radius: .2rem;
    background: url("../assets/img/arrow_left.png") center center no-repeat;
    background-size: 100%;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }
  .imgBox .arrow-right {
    position: absolute;
    right: 0;
    top: 3.7rem;
    width: .4rem;
    height: .4rem;
    -webkit-border-radius: .2rem;
    border-radius: .2rem;
    background: url("../assets/img/arrow_right.png") center center no-repeat;
    background-size: 100%;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }
  .alt-img-box {
    position: relative;
    z-index: 2;
    margin-bottom: .24rem;
  }
  .alt-img-box img {
    width: 100%;
    vertical-align: top;
  }
</style>